import { OAuthResponse } from 'typescript-fetch-api'

import { RootStoreState } from '../root'

export const authTokenSelector = (state: RootStoreState): OAuthResponse | undefined => state.auth.token
